
import '../App.css';
import { AiFillHeart } from "react-icons/ai";
import { SiReact } from "react-icons/si";
import { FaCopyright } from "react-icons/fa";

function Footer() {
  return (
    <div className="Footer">
      <div className='Regular-Footer'>
        <div className="Copyright-Info">
          <FaCopyright className="Copyright-Icon" /> Neeraj Malwal 2021 |
        </div>
        <div>
          <p>Made with ❤️ and </p>
        </div>
        <div>
          <SiReact className="React-Icon" />
        </div>
        <div>
          <p className="Contact">| drop a mail at neerajmalwal10@gmail.com</p>
        </div>
      </div>

      <div className='Mobile-Footer'>

        <div className="Copyright-Info">
          <FaCopyright className="Copyright-Icon" /> Neeraj Malwal 2021
        </div>

      </div>
    </div>
  );
}

export default Footer;
